<template>
  <VCard class="my-3">
    <VDataTable
      :headers="headers"
      :items="agents"
      :rows-per-page-items="[15]"
      :pagination.sync="pagination"
      :total-items="paginationTotal"
      class="text-xs-left"
      :loading="isLoading"
    >
      <tr
        slot="items"
        :key="index"
        slot-scope="{ index, item }"
        @click="$router.push({ name: 'agentOverview', params: { agentId: item.id } })"
      >
        <td>{{ item.number }}</td>
        <td>{{ `${item.first_name} ${item.last_name}` }}</td>
      </tr>
    </VDataTable>

    <VCardActions>
      <VSpacer />

      <AgencyOverviewAgentsCreateEntry @onSuccess="getPaginatedData" />
    </VCardActions>
  </VCard>
</template>

<script>
import PaginationApi from '@/api/PaginationApi'
import AgencyOverviewAgentsCreateEntry from '@/components/routes/agency/AgencyOverviewAgentsCreateEntry'

export default {
  name: 'AgencyOverviewAgentsTable',
  components: { AgencyOverviewAgentsCreateEntry },
  props: ['agencyId'],
  data () {
    return {
      isLoading: false,
      agents: [],
      pagination: {},
      paginationTotal: 0,
      headers: [
        { text: this.$nt('number'), value: 'number', align: 'left', index: '0', sortable: false },
        { text: this.$nt('name'), value: 'name', align: 'left', index: '1', sortable: false }
      ]
    }
  },
  computed: {
    url () {
      if (this.$can('read', 'AllAgents')) {
        return `agencies/${this.agencyId}/agents`
      } else {
        return `agency/agents`
      }
    }
  },
  methods: {
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, undefined, this.pagination.page)
        this.paginationTotal = response.total
        this.agents = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  watch: {
    pagination: {
      handler: 'getPaginatedData'
    }
  }
}
</script>
